import { Component, OnInit } from '@angular/core';
import { PushNotifIdsModel } from '@bt/core';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from "angular-notifier";
import { PushNotifModel, PushNotifSectionService, PushNotifFilterModel } from "@bt/core";
import { faSearch } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-push-notif-section',
  templateUrl: './push-notif-section.component.html',
  styleUrls: ['./push-notif-section.component.scss']
})
export class PushNotifSectionComponent extends BaseComponent implements OnInit {

  faSearch = faSearch;

  public hasInfo: boolean = false;
  public isResponsed: boolean = false;
  notifier: any;
  pushNotifs: PushNotifModel[];
  filter: PushNotifFilterModel;

  constructor(
    private pushNotifSectionService: PushNotifSectionService,
    notifierService: NotifierService,
  ) {
    super();
    this.notifier = notifierService;
   }

  ngOnInit() {
    document.getElementById('pushNotifSection').addEventListener('keydown', (event) => {
      if(event.key == "Enter"){
        document.getElementById('serchButton').click();
      }
    });
    this.filter = new PushNotifFilterModel;
    this.pushNotifs = new Array<PushNotifModel>()
  }

  GetPushNotif(pushNotifFilter: PushNotifFilterModel){
    this.setLoading(true);
    this.pushNotifSectionService.GetPushNotif(pushNotifFilter)
    .then((resp) => {
      this.pushNotifs = resp.data;
      this.hasInfo = resp.data.length != 0;
      this.isResponsed = true;
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении списка уведомлений");
      this.hasInfo = false;
      this.isResponsed = true;
      this.setLoading(false);
    });
  }

  dateOutput(date: string){
    if(date != "01.01.0001 00:0") return date;
  }

}



// WEBPACK FOOTER //
// ./src/app/push-notif-section/push-notif-section.component.ts